
import { useStore } from '@nuxtjs/composition-api'
import experimentsConfig from '@/config/experiments'
import { setupGtmABTestEvent } from '@/assets/composition/setup-gtm'

export default {
  props: {
    experimentId: { type: String, required: true },
    defaultVariant: { type: String, required: false, default: 'A' },
  },
  setup({ experimentId, defaultVariant }) {
    const store = useStore()
    const experimentConfig = experimentsConfig.activeExperiments[experimentId]
    const experiment = store.getters['experiments/experiments'][experimentId]
    const variant = experiment?.enabled && experiment?.variant
    const variantKey = experimentConfig && Object.keys(experimentConfig?.variants).find((key) => experimentConfig?.variants[key] === variant)

    // Send variant to Google Analytics only if the user is part of the test, excluding users not in the test from analytics
    if (variantKey) {
      setupGtmABTestEvent(`${experimentId} - ${variant}`)
    }

    return {
      variantKey: variantKey || defaultVariant,
    }
  },
}
